/* @ngInject */
function HomeCampaignsController ($scope, $state, HomeService, SegmentService) {
  $scope.currentDate = new Date()

  const api = {
    _handleSuccessGetCampaigns
  }
  this.getApi = () => api

  activate()

  function activate () {
    HomeService.getHomeCampaigns(7).then(api._handleSuccessGetCampaigns)
  }

  $scope.openCampaign = function (campaign) {
    $state.go('arts.collection', {
      id: campaign.id,
      pageHistory: []
    })
    SegmentService.track('arts-widget-collection-view')
  }

  $scope.goToArtsClick = function () {
    $state.go('arts.templates')
    SegmentService.track('arts-widget-collection-all')
  }

  function _handleSuccessGetCampaigns (campaigns) {
    if (campaigns.rows.length) {
      $scope.campaigns = campaigns.rows
      $scope.campaignsCount = campaigns.count
    }
  }
}

export { HomeCampaignsController }
